import React from 'react';
import { connect } from 'react-redux';
import CommonService from '../../../../services/commonService';

export const ThemeTenTitle = ({title}) => {
  const operator = CommonService.getLocal('op');



  return (
    <div className="favorite-destinations-heading d-flex align-center justify-center my-4 less-bold-text">
      <span className="d-inline-block title-dash-line"
      style={{background: operator &&  operator.color_codes && operator.color_codes.primary_color}} 
      ></span>
      <div
        className="px-2 text-uppercase m-0"
        style={{
          color:  operator &&  operator.color_codes && operator.color_codes.secondary_color,
          fontSize: '22px',
          fontWeight: 'bold',
        }}
      >
        {title}
      </div>
      <span className="d-inline-block title-dash-line"
      style={{background: operator &&  operator.color_codes && operator.color_codes.primary_color}} 
      ></span>
    </div>
  );
};

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    themes: state.themes,
  };
}


export default connect(mapStateToProps, {})(ThemeTenTitle);



// WEBPACK FOOTER //
// ./src/features/themes/ThemeTen/components/ThemeTenTitle.js